<template>
  <ModalLayout icon="doc" :title="isEdit ? 'Edit Note' : 'Add Note'" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-position="top">
      <el-form-item label="Note" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="4" placeholder="Enter note text" />
      </el-form-item>

      <el-form-item label="Link" prop="link">
        <el-input v-model="form.link" placeholder="Enter URL" />
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="close">Cancel</el-button>
      <el-button type="primary" @click="submitForm" :loading="loading">
        {{ isEdit ? 'Save Changes' : 'Add Note' }}
      </el-button>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from '@/components/social-products/social-boost/modal/ModalLayout.vue'

export default {
  components: { ModalLayout },
  props: {
    meta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        note: this.meta.note?.note || '',
        link: this.meta.note?.link || '',
      },
      rules: {
        note: [{ required: true, message: 'Please enter note text', trigger: 'blur' }],
        link: [{ type: 'url', message: 'Please enter a valid URL', trigger: 'blur' }],
      },
    }
  },
  computed: {
    isEdit() {
      return !!this.meta.note
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async submitForm() {
      try {
        await this.$refs.form.validate()

        this.loading = true
        const endpoint = `/api/social-products/social-boost/notes/${this.meta.asset.id}`
        const method = this.isEdit ? 'put' : 'post'
        const data = {
          note: this.form.note,
          link: this.form.link,
        }

        if (this.isEdit) {
          data.note_id = this.meta.note.id
        }

        await this.axios[method](endpoint, data)
        this.close()
        this.$Modal.parent.init()
      } catch (error) {
        if (error?.message) {
          this.$message.error(error.message)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
